<div>
    <div *ngIf="data.icon" class="flex justify-center items-center mb-8">
        <div class="icon-[12.5rem]" [ngClass]="data.icon"></div>
    </div>
    <div class="flex justify-center items-center">
        <h1 *ngIf="data.title" class="text-center font-bold text-[#231F20] text-lg" [ngClass]="data.titleClass">
            {{ data.title | translate }}
        </h1>
    </div>
    <div
        *ngIf="data.message"
        class="text-center tracking-[0] leading-tight text-[#4B4848] mt-3"
        [innerHTML]="data.message | translate"></div>
</div>
<div class="flex items-center mt-6 space-x-4 justify-center">
    <button
        *ngIf="data.cancelText"
        type="button"
        class="bg-white border-2 border-primary text-primary !rounded-lg w-fit font-bold"
        [ngClass]="data.cancelText ? '!py-3 !px-[1.875rem]' : '!py-4 !px-7'"
        [mat-dialog-close]="false">
        {{ data.cancelText | translate }}
    </button>
    <button
        type="button"
        class="!rounded-lg min-w-[7.5rem] btn-primary"
        [ngClass]="data.cancelText ? '!py-3 !px-[1.125rem]' : '!py-4 !px-7'"
        [mat-dialog-close]="true">
        {{ data.confirmText | translate }}
    </button>
</div>
